import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useTheme } from '../../../../lib/hooks'

import ScannerIndicator from '@/features/Scanner/ScannerIndicator'
import withScanner from '@/features/Scanner/withScanner'
import useLayout from '@/layout/useLayout'

import useCheckout from '../../hooks/useCheckout'
import Step from '../Step/Step'
import { CartEmpty, CartFooter, CartSummary, CartTable } from './Cart.styles'
import CartItem from './CartItem'

const Cart = () => {
  const { cart, cartTotal } = useCheckout()
  const { setShowBack } = useLayout()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const themes = useTheme()

  if (cart.length === 0) {
    navigate('/')
  }

  useEffect(() => {
    setShowBack(true)

    return () => {
      setShowBack(false)
    }
  }, [])

  return (
    <Step>
      {cart.length > 0 && (
        <>
          <CartTable>
            {cart.map(product => (
              <CartItem key={product.id} product={product} />
            ))}
          </CartTable>
          <ScannerIndicator size="small" />
          <CartFooter>
            <CartSummary>
              <dt>{t('total')}</dt>
              {themes.currency === '£' ? <dd>
                {themes.currency}
                {cartTotal.toFixed(2)}
              </dd> : <dd>
                {cartTotal.toFixed(2)}
                {themes.currency}
              </dd>}
            </CartSummary>
          </CartFooter>
        </>
      )}
      {cart.length === 0 && <CartEmpty>{t('cartIsEmpty')}</CartEmpty>}
    </Step>
  )
}

export default withScanner(Cart)
